import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import { StyledProductItem } from './product-item.styled'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const StyledItemContainer = styled.div`
	display: flex;
	flex: 1;
	margin: 70px 5px;
	width: 250px;
`

const StyledWrapper = styled.div`
	overflow: hidden;
	display: block;
	width: 100%;

	.slick-slider {
		position: relative;

		.slick-slide {
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.custom-arrow {
		height: 50px;
		width: 50px;
		background-color: #00000050;
		border-radius: 50%;
		text-align: center;
		align-content: center;
		position: absolute;
		color: #ffffff;
		transition: 0.5s all;
		z-index: 1;

		&:hover {
			background-color: #fff;
			color: #000000;
			border: 1px solid #00000050;
			cursor: pointer;
		}
	}

	.custom-slick-prev {
		top: 40%;
		left: 10px;
	}

	.custom-slick-next {
		top: 40%;
		right: 10px;
	}
`
class InfiniteSlider extends React.Component {
	calculatingItemsToShow({ limit, defaultLimit }) {
		const { data } = this.props

		const itemsQtt = data.length

		return itemsQtt < limit ? itemsQtt : defaultLimit
	}

	render() {
		const { itemsPerPage, data } = this.props

		const hasPagination = data.length > itemsPerPage

		const settings = {
			arrows: hasPagination,
			prevArrow: (
				<CustomArrow
					iconClassName={'custom-slick-prev'}
					icon={'fa fa-angle-left fa-2x'}
				/>
			),
			nextArrow: (
				<CustomArrow
					iconClassName={'custom-slick-next'}
					icon={'fa fa-angle-right fa-2x'}
				/>
			),
			speed: 500,
			autoplay: false,
			autoplaySpeed: 3000,
			pauseOnHover: true,
			slidesToShow: this.calculatingItemsToShow({
				limit: 10,
				defaultLimit: 7.3
			}),
			slidesToScroll: 3,
			dots: hasPagination,
			initialSlide: -1,
			responsive: [
				{
					breakpoint: 2560,
					settings: {
						slidesToShow: this.calculatingItemsToShow({
							limit: 6,
							defaultLimit: 4.6
						}),
						slidesToScroll: 2,
						dots: hasPagination,
						initialSlide: -1,
						centerMode: true,
						infinite: true
					}
				},
				{
					breakpoint: 1440,
					settings: {
						slidesToShow: this.calculatingItemsToShow({
							limit: 6,
							defaultLimit: 4.6
						}),
						slidesToScroll: 2,
						dots: hasPagination,
						initialSlide: 2,
						centerMode: true,
						infinite: true
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: this.calculatingItemsToShow({
							limit: 5,
							defaultLimit: 3.3
						}),
						slidesToScroll: 2,
						dots: hasPagination,
						initialSlide: -2
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: this.calculatingItemsToShow({
							limit: 3,
							defaultLimit: 2.5
						}),
						slidesToScroll: 2,
						dots: hasPagination,
						initialSlide: 2,
						centerMode: true
					}
				},
				{
					breakpoint: 425,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: hasPagination,
						initialSlide: 0
					}
				}
			]
		}

		return (
			<StyledWrapper hasPagination={hasPagination}>
				<Slider {...settings}>
					{data.map((item, index) => {
						return (
							<StyledItemContainer key={item.productName + index}>
								<StyledProductItem key={index}>
									{this.props.renderItem(item, index)}
								</StyledProductItem>
							</StyledItemContainer>
						)
					})}
				</Slider>
			</StyledWrapper>
		)
	}
}

function CustomArrow({ iconClassName, icon, onClick }) {
	return (
		<div className={`custom-arrow ${iconClassName}`} onClick={onClick}>
			<span aria-hidden="true" className={icon} />
		</div>
	)
}

export default InfiniteSlider
